import { render } from "./initial-info.vue?vue&type=template&id=07d6886f&scoped=true"
import script from "./initial-info.vue?vue&type=script&lang=js"
export * from "./initial-info.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./initial-info.vue?vue&type=style&index=1&id=07d6886f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d6886f"]])

export default __exports__